export default function reducer(state={
    list:[],
    activeDeal:{
        title:"",
        id:0,
        description:"",
        discount:null,
        image_name:null,
        updated:false,
    },
    activeSubscription:{
        id:0,
        deal_id:null,
        user_id:null,
        from_date:new Date(),
        to_date:new Date(),
        activities:[],
        updated:false,
        subbed:false
    }
},action){

    switch(action.type){
        case "STORE_DEALS":{
            return{...state,list:action.deals}
        }
        case "STORE_ACTIVE_DEAL":{
            return{...state,activeDeal:{
                ...state.activeDeal,
                id:action.deal.id,
                title:action.deal.title,
                description:action.deal.description,
                discount:action.deal.discount,
                image_name:action.deal.image_name,
                updated:true
            }}
        }
        case "LOCK_ACTIVE_DEAL":{
            return{...state,activeDeal:{
                ...state.activeDeal,                
                updated:false
            }}
        }
        case "STORE_ACTIVE_SUBSCRIPTION":{
            return{...state,activeSubscription:{
                ...state.activeSubscription,
                id:action.sub.id,
                deal_id:action.sub.deal_id,
                user_id:action.sub.user_id,
                from_date:action.sub.from_date,
                to_date:action.sub.to_date,
                activities:action.sub.activities,
                subbed:action.sub.subbed,
                updated:true,
            }}
        } 
        case "LOCK_ACTIVE_SUBSCRITION":{
            return{...state,activeSubscription:{
                ...state.activeSubscription,                
                updated:false
            }}
        }        
    }

    return state;
}